export default function Logo(props) {
  return (
    <svg
      width="131"
      height="19"
      viewBox="0 0 131 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M120.646 14.9804L123.734 3.23535H127.593L130.68 14.9804H128.398L127.761 12.3965H123.566L122.928 14.9804H120.646ZM124.086 10.3495H127.24L125.814 4.62798H125.512L124.086 10.3495Z"
        fill="black"
      />
      <path
        d="M117.027 14.9804V3.23535H119.242V14.9804H117.027Z"
        fill="black"
      />
      <path
        d="M106.017 14.9804V3.23535H108.231V8.08438H112.594V3.23535H114.809V14.9804H112.594V10.0978H108.231V14.9804H106.017Z"
        fill="black"
      />
      <path
        d="M98.8711 14.9804V5.24879H95.4482V3.23535H104.509V5.24879H101.086V14.9804H98.8711Z"
        fill="black"
      />
      <path
        d="M86.8623 14.9804V3.23535H94.4127V5.24879H89.0771V8.05082H93.9429V10.0643H89.0771V12.967H94.5134V14.9804H86.8623Z"
        fill="black"
      />
      <path
        d="M72.0664 14.9804V3.23535H76.1772L78.2074 13.4703H78.5094L80.5396 3.23535H84.6504V14.9804H82.5027V4.86288H82.2007L80.1873 14.9804H76.5295L74.5161 4.86288H74.2141V14.9804H72.0664Z"
        fill="black"
      />
      <path
        d="M65.2912 15.2148C63.8147 15.2148 62.6402 14.8122 61.7677 14.0068C60.8952 13.1902 60.459 12.0269 60.459 10.5168V7.69802C60.459 6.18794 60.8952 5.03021 61.7677 4.22484C62.6402 3.40828 63.8147 3 65.2912 3C66.7677 3 67.9423 3.40828 68.8147 4.22484C69.6872 5.03021 70.1235 6.18794 70.1235 7.69802V10.5168C70.1235 12.0269 69.6872 13.1902 68.8147 14.0068C67.9423 14.8122 66.7677 15.2148 65.2912 15.2148ZM65.2912 13.235C66.119 13.235 66.7622 12.9945 67.2208 12.5135C67.6794 12.0325 67.9087 11.3893 67.9087 10.5839V7.6309C67.9087 6.82553 67.6794 6.18235 67.2208 5.70136C66.7622 5.22037 66.119 4.97988 65.2912 4.97988C64.4747 4.97988 63.8315 5.22037 63.3617 5.70136C62.9031 6.18235 62.6738 6.82553 62.6738 7.6309V10.5839C62.6738 11.3893 62.9031 12.0325 63.3617 12.5135C63.8315 12.9945 64.4747 13.235 65.2912 13.235Z"
        fill="black"
      />
      <path
        d="M50.126 14.9804V3.23535H55.2267C55.9649 3.23535 56.6081 3.36399 57.1562 3.62126C57.7043 3.87853 58.1294 4.24207 58.4314 4.71187C58.7334 5.18167 58.8844 5.73537 58.8844 6.37296V6.5743C58.8844 7.279 58.7166 7.84948 58.3811 8.28572C58.0455 8.72196 57.6316 9.04076 57.1394 9.2421V9.54412C57.5869 9.56649 57.9336 9.72309 58.1797 10.0139C58.4258 10.2936 58.5489 10.6683 58.5489 11.1381V14.9804H56.3341V11.4569C56.3341 11.1884 56.2614 10.9703 56.1159 10.8025C55.9817 10.6347 55.7524 10.5508 55.428 10.5508H52.3408V14.9804H50.126ZM52.3408 8.5374H54.9918C55.5175 8.5374 55.9258 8.39758 56.2166 8.11793C56.5186 7.8271 56.6696 7.44679 56.6696 6.97699V6.8092C56.6696 6.3394 56.5242 5.96468 56.2334 5.68503C55.9426 5.3942 55.5287 5.24879 54.9918 5.24879H52.3408V8.5374Z"
        fill="black"
      />
      <path
        d="M40 14.9804V3.23535H44.8322C45.5705 3.23535 46.2193 3.38636 46.7786 3.68837C47.349 3.9792 47.7909 4.39308 48.1041 4.92999C48.4285 5.46691 48.5907 6.1045 48.5907 6.84276V7.07766C48.5907 7.80473 48.4229 8.44232 48.0873 8.99042C47.7629 9.52734 47.3155 9.9468 46.745 10.2488C46.1857 10.5396 45.5481 10.6851 44.8322 10.6851H42.2148V14.9804H40ZM42.2148 8.67163H44.6141C45.1399 8.67163 45.5649 8.52621 45.8893 8.23538C46.2137 7.94456 46.3759 7.54746 46.3759 7.0441V6.87632C46.3759 6.37296 46.2137 5.97586 45.8893 5.68503C45.5649 5.3942 45.1399 5.24879 44.6141 5.24879H42.2148V8.67163Z"
        fill="black"
      />
      <path
        d="M14.4596 2.1809L0 15.8487C4.89208 19.7022 9.76717 17.8557 11.5932 16.4508L19.1734 9.34596C20.1926 8.74386 20.9569 9.34596 20.9569 9.34596C21.6576 9.94807 21.3125 10.7667 21.148 11.0319L14.8418 17.0529C20.7658 20.6054 24.9063 18.6184 27.7727 16.4508C30.6392 14.2832 33.5056 7.11817 27.3268 2.1809C22.3838 -1.76892 16.6891 0.535141 14.4596 2.1809Z"
        fill="#FF555E"
      />
    </svg>
  );
}
